export default __webpack_public_path__ + "static/sgx-e99d09ed2b6c6fa837677f83876bfb49.png";